import { useState, useEffect } from 'react';

const slides = [
  {
    src: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/cb6cf83152b2e9f5faae4dff399c104e.jpeg',
    caption: 'Pruebas de estabilidad y análisis en tubos graduados — laboratorio técnico',
  },
  {
    src: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/be6145dda7a993f7c8819b4957e59eb9.png',
    caption: 'Operaciones en campo — equipos de bombeo activos al atardecer',
  },
  {
    src: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/d927f2491c29eedfbfdff183c7407c79.jpeg',
    caption: 'Formulación de aditivos — muestras preparadas para evaluación de campo',
  },
  {
    src: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/7b8ca49b50f5c7f8666e0caddb405160.jpeg',
    caption: 'Balancín venezolano — símbolo de la industria petrolera nacional',
  },
  {
    src: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/078a8d9f847a331b65c3b0a6daaf5563.jpeg',
    caption: 'Laboratorio de química avanzada — desarrollo de nuevas formulaciones',
  },
  {
    src: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/50f4980ba85735ba5fe3838203eb7c27.jpeg',
    caption: 'Fluido de perforación activo — mezcla de lodo en operaciones de campo',
  },
  {
    src: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/4391104b0a5ec37ea08d931cfb801c88.jpeg',
    caption: 'Pruebas de separación crudo-agua en tubos graduados — ensayo de demulsificantes',
  },
  {
    src: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/20ef1e4b1c6fc3deb4822882313044ed.jpeg',
    caption: 'Lodo de perforación en agitación — proceso de mezcla con aditivos químicos',
  },
  {
    src: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/82c727ebc95c127b734df257ae7b9094.jpeg',
    caption: 'Muestras numeradas en baño calefactor — evaluación térmica de formulaciones',
  },
  {
    src: 'https://static.readdy.ai/image/51f676c9cc2d72a77723e075d004b9cd/c86c4617ec100409b4628851bf05d2a9.jpeg',
    caption: 'Instalaciones PDVSA — tanque de almacenamiento y tuberías de producción',
  },
];

export default function ImageSlider() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % slides.length);
        setAnimating(false);
      }, 400);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const goTo = (index: number) => {
    if (index === current) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setAnimating(false);
    }, 400);
  };

  return (
    <section className="w-full py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-widest uppercase mb-4">
            Nuestra Operación
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            En el campo y en el laboratorio
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Desde la formulación hasta la entrega, estamos presentes en cada etapa del proceso.
          </p>
        </div>

        {/* Slider */}
        <div className="relative w-full overflow-hidden rounded-2xl bg-foreground-950 shadow-none">
          {/* Main image */}
          <div className="relative w-full h-[420px] md:h-[580px]">
            {slides.map((slide, i) => (
              <img
                key={i}
                src={slide.src}
                alt={slide.caption}
                className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-500 ${
                  i === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
                } ${animating && i === current ? 'opacity-0' : ''}`}
              />
            ))}

            {/* Dark overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent z-20" />

            {/* Caption */}
            <div className="absolute bottom-0 left-0 right-0 z-30 px-8 py-6">
              <p
                className={`text-white text-sm md:text-base font-medium transition-all duration-500 ${
                  animating ? 'opacity-0 translate-y-2' : 'opacity-100 translate-y-0'
                }`}
              >
                {slides[current].caption}
              </p>
            </div>

            {/* Arrow buttons */}
            <button
              onClick={() => goTo((current - 1 + slides.length) % slides.length)}
              className="absolute left-4 top-1/2 -translate-y-1/2 z-30 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-white text-xl" />
            </button>
            <button
              onClick={() => goTo((current + 1) % slides.length)}
              className="absolute right-4 top-1/2 -translate-y-1/2 z-30 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm transition-all cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-white text-xl" />
            </button>

            {/* Slide counter */}
            <div className="absolute top-5 right-5 z-30 bg-black/30 backdrop-blur-sm text-white text-xs px-3 py-1.5 rounded-full font-medium">
              {current + 1} / {slides.length}
            </div>
          </div>


        </div>

        {/* Dot indicators */}
        <div className="flex justify-center gap-2 mt-6">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className={`transition-all cursor-pointer rounded-full ${
                i === current
                  ? 'w-8 h-2.5 bg-primary-500'
                  : 'w-2.5 h-2.5 bg-background-300 hover:bg-primary-300'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}